import { ChargifyCurrencyPipe } from '../../shared/pipes/chargify-currency.pipe';

export function chargifyCurrency ( chargifyCurrencyPipe : ChargifyCurrencyPipe ) {
  return ( value : any ) : string => chargifyCurrencyPipe.transform(value);
};